export default function(api: GlobalFetch) {
  return async function() {
    let cookiesPayload = null
    try {
      const raw = localStorage.getItem('cookies_v2') || localStorage.getItem('cookies')
      cookiesPayload = raw ? JSON.parse(raw) : null
    } catch (e) {
      cookiesPayload = null
    }

    const response = await api.fetch('/api/v2/user/cookie', {
      body: JSON.stringify({cookies_information: cookiesPayload}),
      method: 'POST',
    })

    return response.status === 200
  }
}
